var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"runner",staticClass:"tab-runner",class:("theme-" + _vm.theme)})}
var staticRenderFns = []

export { render, staticRenderFns }